import { render, staticRenderFns } from "./complementari.vue?vue&type=template&id=8341fa26&scoped=true&"
import script from "./complementari.vue.ts?vue&type=script&lang=ts&"
export * from "./complementari.vue.ts?vue&type=script&lang=ts&"
import style0 from "./complementari.vue?vue&type=style&index=0&id=8341fa26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8341fa26",
  null
  
)

export default component.exports